var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"airportList"},_vm._l((_vm.list),function(item){return _c('AirportItem',{key:item.airportName,staticClass:"airportItem",attrs:{"item":item,"locale":_vm.locale,"lang":_vm.lang}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }